module.exports = __webpack_public_path__ + "img/donante-imac.373e0ead.png";